import { createSvgIcon } from '@mui/material/utils';
import React, { memo } from 'react';
const SvgIcon = createSvgIcon([
    React.createElement("path", { key: '0', d: 'M4.3,4.2l0,5.7h2.8v2.8h2.8l0.2,0.2c-1.1,2.2-0.7,5,1.2,6.8c2.3,2.3,6.1,2.3,8.5,0s2.3-6.1,0-8.5c-1.8-1.8-4.6-2.2-6.8-1.2\n\t\tL7.1,4.2L4.3,4.2z M13.4,13.4c1.2-1.2,3.1-1.2,4.2,0c1.2,1.2,1.2,3.1,0,4.2c-1.2,1.2-3.1,1.2-4.2,0C12.2,16.5,12.2,14.6,13.4,13.4z\n\t\t' }),
], 'TransportAccStatus');
const TransportAccStatusIcon = function (props) {
    return React.createElement(SvgIcon, Object.assign({}, props));
};
export default memo(TransportAccStatusIcon);
